import createCustomError from 'common/util/createCustomError';
import validateInput from 'common/validateInput';

import { type Filter } from '../constants';
import { isFilterBoardURLName, isFilterPostContent } from '../filterUtils';

export const ValidateAutomationFilterError = createCustomError('validateAutomation');
const validateFilter = (filter: Filter) => {
  if (isFilterBoardURLName(filter)) {
    return validateInput.urlName(filter.value);
  } else if (isFilterPostContent(filter)) {
    return (
      validateInput.oneOf(['containsAll', 'containsAny'])(filter.condition) &&
      validateInput.arrayOf(
        (value: string) => typeof value === 'string' && value.length >= 3,
        1,
        5
      )(filter.value)
    );
  } else {
    throw new ValidateAutomationFilterError({
      message: `Invalid filter: ${(filter as Filter).resource}`,
      filter,
    });
  }
};

export default validateFilter;
